export const DynamicFieldsTypes = {
  CHECKBOX: 'Checkbox',
  FLOW_SELECTION: 'FlowSelection',
} as const;
